export default __webpack_public_path__ + "static/media/linkedin_icon.f43a1e11.png";